import React from 'react';
import MyOverview from '../my-overview-page';
import { IRootUser } from '../../../common';

interface IDashboardProps extends IRootUser {}

export const Dashboard = (props: IDashboardProps) => {
  return (
    <div className="flex flex-col gap-6 max-lg:max-w-[calc(100%-4rem)] max-w-[calc(100%-6rem)] pt-6 mx-auto min-h-screen">
      <MyOverview isAdmin={props.isAdmin} />
    </div>
  );
};
